import { Plus, Trash2 } from "lucide-react";
import { Input } from "./ui/input";
import { Textarea } from "./ui/textarea";

const BASE_SECTIONS = [
  ["executive_summary", "Executive Summary"],
  ["property_details", "Property Details"],
  ["score", "Overall Property Score"],
  ["room_summary", "Room-wise Summary"],
  ["reinspection", "Before vs After Comparison"],
  ["detailed_observations", "Detailed Observations"],
  ["rectification_summary", "Rectification Summary"],
  ["limitations", "Inspection Limitations"],
  ["disclaimer", "Disclaimer"],
  ["contact", "Company Contact"],
];

const defaultSections = () =>
  BASE_SECTIONS.map(([id, title]) => ({
    id,
    title,
    visible: true,
  }));

export function ReportSectionDefaults({ value, onChange }) {
  const sections = value?.length ? value : defaultSections();
  const update = (id, patch) => {
    onChange(
      sections.map((section) =>
        section.id === id ? { ...section, ...patch } : section,
      ),
    );
  };

  const add = () => {
    onChange([
      ...sections,
      {
        id: `custom_${Date.now().toString(36)}`,
        title: "Additional Information",
        content: "",
        visible: true,
      },
    ]);
  };

  return (
    <div className="space-y-4">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div>
          <div className="overline">New report defaults</div>
          <p className="mt-1 text-sm text-slate-600">
            These titles and visibility settings are applied to future
            inspections only.
          </p>
        </div>
        <button
          onClick={add}
          className="tap flex h-10 items-center gap-2 rounded-md border border-slate-900 px-4 text-sm font-semibold"
          data-testid="default-report-add-section-button"
        >
          <Plus className="h-4 w-4" />
          Add section
        </button>
      </div>
      <div className="space-y-2">
        {sections.map((section) => (
          <div
            key={section.id}
            className="grid gap-3 rounded-md border border-slate-200 p-3 md:grid-cols-[1fr_auto_auto]"
            data-testid={`default-report-section-${section.id}`}
          >
            <div className="space-y-2">
              <Input
                value={section.title}
                onChange={(event) =>
                  update(section.id, { title: event.target.value })
                }
                data-testid={`default-report-section-title-${section.id}`}
              />
              {section.id.startsWith("custom_") && (
                <Textarea
                  rows={3}
                  value={section.content || ""}
                  onChange={(event) =>
                    update(section.id, { content: event.target.value })
                  }
                  data-testid={`default-report-section-content-${section.id}`}
                />
              )}
            </div>
            <button
              onClick={() => update(section.id, { visible: !section.visible })}
              className="tap h-10 rounded-md border border-slate-200 px-3 text-sm font-semibold"
              data-testid={`default-report-section-toggle-${section.id}`}
            >
              {section.visible ? "Hide" : "Restore"}
            </button>
            {section.id.startsWith("custom_") && (
              <button
                onClick={() =>
                  onChange(sections.filter((item) => item.id !== section.id))
                }
                className="tap grid h-10 w-10 place-items-center rounded-md border border-rose-200 text-rose-600"
                data-testid={`default-report-section-remove-${section.id}`}
              >
                <Trash2 className="h-4 w-4" />
              </button>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
